import { companyTypeSchema } from './corporate_id.js';
import { corporateIdSchema } from './corporate_id.js';
import { z } from 'zod';

export const clientSchema = z.object({
  name: z.string(),
  corporateId: corporateIdSchema,
  companyType: companyTypeSchema,
});
export type Client = z.infer<typeof clientSchema>;

export const companySchema = z.object({
  name: z.string(),
  corporateId: corporateIdSchema,
});
export type Company = z.infer<typeof companySchema>;
